module.exports = __webpack_public_path__ + "static/media/diamonds_4.32e21224.png";